// On check pas le service worker, car declarative web push ne nécessite pas de sw
export const isNotificationSupported =
  "Notification" in window &&
  ("pushManager" in window || "PushManager" in window);
